module.exports = __webpack_public_path__ + "static/media/selfie-face-standard.a9541987.svg";